<template>
  <div class="mission-list-tabs-parts">
    <ul class="mission-list-tabs-parts__list">
      <li v-for="tab in tabs" :key="tab.id" class="mission-list-tabs-parts__item">
        <router-link
          :to="tab.path"
          class="mission-list-tabs-parts__item-link"
          :class="{ 'mission-list-tabs-parts__item-link--current': currentTab === tab.id }"
          >{{ tab.name }}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import I18n from '@/locales/I18n'

export default defineComponent({
  name: 'MissionListTabsParts',
  props: {
    currentTab: {
      type: String,
      default: 'mission',
    },
  },
  setup() {
    const tabs = [
      {
        id: 'mission',
        name: I18n.tc('MissionPage.tabs.mission'),
        path: '/mission',
      },
      {
        id: 'ranking',
        name: I18n.tc('MissionPage.tabs.ranking'),
        path: '/mission/ranking',
      },
    ]
    return {
      tabs,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-list-tabs-parts {
  &__list {
    display: flex;
    width: 260px;
    height: 36px;
    padding: 2px;
    margin-right: auto;
    margin-left: auto;
    background-color: rgba(#909090, 0.3);
    border-radius: 17px;
    backdrop-filter: blur(10px);
  }

  &__item {
    width: 50%;
    height: 100%;

    &-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      font-size: 12px;
      font-weight: bold;
      color: $white;
      letter-spacing: 0.04em;

      &--current {
        color: $black;
        background-color: $white;
      }
    }

    &:nth-child(1) {
      .mission-list-tabs-parts__item-link--current {
        border-radius: 16px 2px 2px 16px;
      }
    }

    &:nth-child(2) {
      .mission-list-tabs-parts__item-link--current {
        border-radius: 2px 16px 16px 2px;
      }
    }
  }
}
</style>
